import "./auth.css";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { forgetPassword } from "./authServices";
import { useNavigate, Link } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { FaFacebook } from "react-icons/fa";
import { BsGithub, BsGoogle } from "react-icons/bs";
import login from "../../Assets/login.svg";
import logo from "../../Assets/logo.svg";

export default function PasswordOublier() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const { email } = data;
    forgetPassword(email, navigate);
  };

  return (
    <div className="container-fluid p-0 " id="login">
      <div className="row d-flex justify-content-center align-items-center w-100 min-vh-100">
        <div className="col-lg-6  p-0 pt-0 d-none d-lg-block">
          <div className="container-bg style-border  d-flex justify-content-center align-items-center w-100 min-vh-100 ">
            <img src={login} className="img-fluid imLogin" />
          </div>
        </div>

        <div className="col-lg-6  p-4  min-vh-100">
          <div className="container-img w-100 d-flex justify-content-center text-center">
            <img src={logo} className="img-fluid logLogin " />
          </div>
          <div className="tiitle-h2">
            <h2>Mot de passe oublié !</h2>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)} className="mx-auto">
            <Form.Group className="text-center" controlId="formBasicEmail">
              <Form.Label>Adresse email</Form.Label>
              <Form.Control
                {...register("email", {
                  require: true, maxLength: 25,
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                })}
                type="email"
                placeholder="Entrez votre mail"
              />
              {errors?.email?.type === "maxLength" && (
                <p className="text-danger">La longueur maximal est de 25 lettres</p>
              )}
              {errors?.email?.type === "pattern" && (
                <p className="text-danger">Entrez un email valide</p>
              )}
            </Form.Group>
            <div className="mesBtn my-3 d-flex justify-content-center">
              <button
                type="submit"
                className="block-btn btn btn-md-lg me-2"
              >
                Reinitialiser
              </button>
              <button
                className="block-btn1 btn btn-md-lg ms-2"
              >
                <Link to={"/"}>
                  <span> Connectez-vous !</span>
                </Link>
              </button>
            </div>
            <ToastContainer />
          </Form>
        </div>
      </div>
    </div>
  );
}
